import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { DiliTextCP } from "../Utility/DiliTextCP";
import handleApiError from "../../helpers/handleApiError";

export const DisplayNameEditModal = ({
  show,
  onHide,
  finishEditDisplayName,
  currentDisplayName,
  initialDisplayName,
  saveChanges,
  handleEditDisplayName,
  cancelEditDisplayName,
  history,
}) => {
  const onCancelDisplayName = (e) => {
    cancelEditDisplayName();
    onHide();
  };

  const handleOnFinishClick = async () => {
    const success = await saveChanges();
    if (success) {
      onHide();
    }
  };

  return (
    <Modal show={show} onHide={onCancelDisplayName} backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Edit Display Name</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <DiliTextCP
          required={true}
          label="Display Name"
          value={currentDisplayName}
          onChange={handleEditDisplayName}
          maxLength={25}
        />
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={onCancelDisplayName}
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleOnFinishClick}
        >
          Finish
        </button>
      </Modal.Footer>
    </Modal>
  );
};
